import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const PageHero = ({ eyebrow, title, text, image, cta, testid = "page-hero" }) => (
  <section className="noise relative overflow-hidden bg-[#123634]" data-testid={testid}>
    {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />}
    <div className="absolute inset-0 bg-gradient-to-r from-[#123634] via-[#123634]/90 to-[#123634]/40" />
    <div className="grid-lines absolute inset-0 opacity-40" />
    <div className="container-x relative py-20 sm:py-24 lg:py-28">
      <p className="eyebrow text-[#E8927F]">{eyebrow}</p>
      <h1 className="mt-4 max-w-3xl text-4xl font-extrabold leading-[1.08] text-white sm:text-5xl lg:text-6xl">{title}</h1>
      {text && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{text}</p>}
      {cta && (
        <Link to={cta.to} className="btn-primary mt-8" data-testid={`${testid}-cta`}>
          {cta.label} <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  </section>
);

export const CtaBand = () => (
  <section className="bg-white py-20" data-testid="cta-band">
    <div className="container-x">
      <div className="noise relative overflow-hidden rounded-2xl bg-[#123634] px-8 py-14 sm:px-14">
        <div className="grid-lines absolute inset-0 opacity-30" />
        <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#C20500]/25 blur-3xl" />
        <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <p className="eyebrow text-[#E8927F]">Consultative, not checkout</p>
            <h2 className="mt-3 text-2xl font-bold text-white sm:text-3xl lg:text-4xl">Planning a multi-site or bulk requirement?</h2>
            <p className="mt-4 text-slate-300">Tell us the products and the site in 2 minutes. A Vinsafe specialist replies within one business day with pricing.</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to="/enquiry" className="btn-primary" data-testid="cta-band-enquiry-button">Get a quote <ArrowRight className="h-4 w-4" /></Link>
            <Link to="/amc" className="inline-flex items-center justify-center rounded-lg border border-white/25 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10" data-testid="cta-band-amc-button">Explore AMC</Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);
